import React, { useContext } from "react";
import ProgressIndicator from "./common/ProgressIndicator";
import { GameContext } from "../context/GameContext";

const Result = () => {
  const { userAnswer, restartGame, questionsArray, quitGame } =
    useContext(GameContext);

  const countCorrect = () => {
    var count = 0;

    for (var i in userAnswer) {
      if (userAnswer[i].correct) {
        count++;
      }
    }
    return count;
  };

  return (
    <main className="result_container">
      <div className="result_content">
        <p className="result_text-xl">
          Resultat: {countCorrect()} rätt
          <span className="result_text-sm"> av {questionsArray.length}</span>
        </p>
        <button className="restart_button" onClick={restartGame}>
          Spela igen
        </button>
        <button className="restart_button" onClick={(e) => quitGame(e)}>
          Gå till Studieförbundet Vuxenskolan
        </button>
        <ProgressIndicator />
      </div>
    </main>
  );
};

export default Result;
